/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  ProfileSubscription
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get Subscription Info
 */
export const getProfileSubscription = (

 signal?: AbortSignal
) => {


      return axiosClient<ProfileSubscription>(
      {url: `/profile/subscription`, method: 'GET', signal
    },
      );
    }




export const getGetProfileSubscriptionQueryKey = () => {
    return [
    'profile','subscription'
    ] as const;
    }


export const getGetProfileSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getProfileSubscription>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSubscription>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProfileSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileSubscription>>> = ({ signal }) => getProfileSubscription(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileSubscription>>, TError, TData>
}

export type GetProfileSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileSubscription>>>
export type GetProfileSubscriptionQueryError = ErrorType<void>


/**
 * @summary Get Subscription Info
 */

export function useGetProfileSubscription<TData = Awaited<ReturnType<typeof getProfileSubscription>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






